import * as AccordionPrimitive from '@radix-ui/react-accordion';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';

export const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item className={twMerge('border-b', className)} ref={ref} {...props} />
));
AccordionItem.displayName = 'AccordionItem';
